<template>
  <div>
    <v-row
      justify="center">
      <v-spacer></v-spacer>
      <div>
        Is this person living?
        <v-radio-group
          v-model="data[modifyIndex].isLiving"
          true-value="true"
          false-value="false">
          <v-radio
            label="Yes"
            :value="true"></v-radio>
          <v-radio
            label="No"
            :value="false"></v-radio>
        </v-radio-group>
      </div>
      <v-spacer v-show='!data[modifyIndex].isLiving'></v-spacer>
      <div
        v-show='!data[modifyIndex].isLiving'>
        What year did this person pass away?
        <v-text-field
          v-model="data[modifyIndex].death"
          label="Year of Death"
          prepend-icon="event"></v-text-field>
          <v-text-field
          v-model="data[modifyIndex].causeofdeath"
          label="Cause of death"
          ></v-text-field>
      </div>
      <v-spacer></v-spacer>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    data: Array,
    modifyIndex: Number
  },
  data: () => ({
    date: null,
    menu: false,
    yearRules: [
      v => /^\d{4}$/.test(v) || /^\d{0}$/.test(v) || 'Please enter a valid year of birth'
    ],
  })
};
</script>
